import { css, html } from 'lit';
import { buildAllButtonDetails, renderCommerceCta, renderCommerceLink } from '../utility.js';
import BaseOfferAwareComponent from './baseOfferAwareComponent.js';
export default class BaseListicleItem extends BaseOfferAwareComponent {
    constructor() {
        super(...arguments);
        /**
         * The function used to render a link, replace this to alter output
         * @see renderCommerceLink
         */
        this.renderLink = renderCommerceLink;
        /**
         * The function used to render a CTA button
         * @see renderCommerceCta
         */
        this.renderCta = renderCommerceCta;
    }
    /**
     * Getter used to define the maximum number of offers that can be displayed
     *
     * This is a getter rather than an integer value to allow for easier querying
     * of context or of values on a window object.  By default it returns 3 for
     * configs where "choose best offer" is true
     */
    get offerCount() {
        return this.config?.options?.chooseBestOffer === true ? 3 : 1;
    }
    /**
     * Getter used to define the default button text to use for cta's
     *
     * This is a getter rather than an integer value to allow for easier querying
     * of context or of values on a window object
     */
    get defaultButtonText() {
        return 'Get It At {Store}';
    }
    render() {
        this.selectOffers(this.config?.item);
        if (this.offerSelection?.primaryOffer === undefined) {
            return html ``;
        }
        return html `<div class="listicle-item">
            ${this.renderImage()}
            <div class="listicle-item--product-info">
                ${this.renderItemTitle()} ${this.renderProductTitle()} ${this.renderOffers()}
            </div>
        </div>`;
    }
    renderItemTitle() {
        const heading = this.config?.listItemHeading ?? '';
        if (heading === '') {
            return html ``;
        }
        return html `<div class="listicle-item--title">
            ${this.renderLink(heading, this.offerSelection?.primaryOffer ?? '', this.item, this.config?.options)}
        </div>`;
    }
    /**
     * Render the product title with markup.
     * In the react implementation it might be good to separate this into a build->render
     * function pair
     */
    renderProductTitle() {
        const offer = this.offerSelection?.primaryOffer;
        const titleText = this.config?.item?.title ?? 'Unknown Item';
        let titleContents = titleText;
        if (offer !== undefined) {
            /**
             * @todo remove the typecast after fixing the partial issue
             */
            titleContents = this.renderLink(titleText, offer, this.config?.item, this.config?.options);
        }
        return html `<div class="listicle-item--product-title">${titleContents}</div>`;
    }
    renderOffers() {
        const offers = this.offerSelection?.selectedOffers;
        if (offers === undefined || offers.length === 0) {
            return html `<span class="listicle-item--no-offers">No offers found</span>`;
        }
        const offerDetails = buildAllButtonDetails(offers, this.config?.options ?? {}, this.defaultButtonText);
        return offerDetails.map((details) => this.renderOfferBuyButton(details));
    }
    renderOfferBuyButton(offerButtonDetails) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        return this.renderCta(offerButtonDetails, this.config?.item, this.config?.options, undefined, {}, 'listicle-item--cta-button');
    }
}
BaseListicleItem.styles = css `
        .listicle-item--image {
            max-width: 100%;
        }
        .listicle-item--title {
            color: var(--item-title-color);
            font-family: var(--item-title-font-family);
            font-size: var(--item-title-font-size);
            font-weight: var(--item-title-font-weight);
        }
        .listicle-item--product-title {
            a {
                color: var(--product-title-color);
                font-family: var(--product-title-font-family);
                font-size: var(--product-title-font-size);
                font-weight: var(--product-title-font-weight);
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
        .listicle-item--cta-button {
            background-color: var(--cta-button-background-color);
            font-family: var(--cta-button-font-family);
            font-size: var(--cta-button-font-size);
            font-weight: var(--cta-button-font-weight);
            margin: 10px 0;
            padding: 10px;
            text-align: center;
            text-transform: var(--cta-button-text-transform);
            @media only screen and (min-width: 430px) {
                width: 50%;
            }
            box-shadow: 4px 4px 0px var(--palette_primary);
            a {
                color: var(--cta-button-text-color);
                text-decoration: none;
            }
        }
        .listicle-item--product-info {
            display: inline;
        }
        @media only screen and (min-width: 1024px) {
            .listicle-item {
                display: flex;
                align-items: center;
            }
            .listicle-item--product-info {
                width: 40%;
            }
            .listicle-item--phoenix-picture {
                width: 60%;
                padding-right: 2rem;
            }
        }
    `;
//# sourceMappingURL=baseListicleItem.js.map